import { StoreCommunicationStatModel } from "@common/models";
import { trackPromise } from "react-promise-tracker";
import { http } from "@common/utils";

export class StoreService {
  private static baseUrl: string = "/api/store";

  public static tags = {
    getStoreCommunicationStats: "getStoreCommunicationStats",
  };

  static getStoreCommunicationStats = (storeId: number): Promise<StoreCommunicationStatModel> => {
    return trackPromise(
      new Promise<StoreCommunicationStatModel>((resolve, reject) => {
        http(`${this.baseUrl}/${storeId}/communicationstats`)
          .get<StoreCommunicationStatModel>()
          .then((storeCommStat) => {
            const storeCommStatModel = new StoreCommunicationStatModel(storeCommStat);
            resolve(storeCommStatModel);
          })
          .catch(() => reject());
      })
    , this.tags.getStoreCommunicationStats);
  };
}
